<template>
  <v-layout class="drawer-container" column >
    <v-toolbar class="header-list">
      <strong>{{$tc(`Admin.${itemTypeName}.List.Nb${itemTypeName}`,items.length)}}</strong>
      <v-spacer/>
      <!-- <mission-operator-filter />    -->
      <v-btn icon :to="{name:`New${itemTypeName}`}" exact :title="$t(`Admin.${itemTypeName}.List.AddTooltip`)" ><v-icon>mdi-plus</v-icon></v-btn>
      <v-btn :input-value="filterVisible" icon @click.stop.prevent="toggleFilter" :title="$t('Admin.FilterTooltip')" >
        <v-badge color="#dd0000" >
          <template v-slot:badge v-if="hasFilter"> 
            <v-menu open-on-hover >
              <span slot="activator">{{nbFiltre}}</span>
              <v-list>
                <v-list-tile>
                  <v-btn @click="resetFilter">{{$t('Admin.ResetFilterTooltip')}}<v-icon right>mdi-filter-remove</v-icon></v-btn>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
          <v-icon>mdi-filter</v-icon>
        </v-badge>                
      </v-btn>        
    </v-toolbar>          
    <component :is="componentFilterName" :itemTypeName="itemTypeName" v-if="filterVisible" class="filter" />
    <div ref="liste" class="liste mt-1" >     
      <v-expansion-panel  >
        <v-expansion-panel-content v-if="basicLayers.length > 0">
          <div slot="header" class="d-flex align-center" >BASIC LAYER</div>
          <component :is="componentLineName" :itemTypeName="itemTypeName" :item="layer" v-for="layer in basicLayers" :key="layer.id" />        
        </v-expansion-panel-content>
        <v-expansion-panel-content v-for="group in groupLayers" :key="group.key">
          <div slot="header" class="d-flex align-center" >
            <template v-if="editLayerKey == group.key">
              <v-text-field @click.stop="" hide-details  :label="$t('Admin.MapLayer.Form.Group')" v-model="editLayerNewName" @keyup.esc="cancelLayerName"  @keyup.enter="saveLayerName(group)" />
              <v-btn @click.prevent.stop="cancelLayerName()" icon small class="flex-grow-0"><v-icon small>mdi-close</v-icon></v-btn>
              <v-btn @click.prevent.stop="saveLayerName(group)" icon small class="flex-grow-0"><v-icon small>mdi-content-save</v-icon></v-btn>
            </template>
            <template v-else>
              <v-btn @click.prevent.stop="editLayerName(group)" icon small class="flex-grow-0"><v-icon small>mdi-pencil</v-icon></v-btn>
              {{group.key}}
            </template>            
            <!--{{$t(`Pilot.Layer.${group.key}`).replace('Pilot.Layer.','')}}-->
          </div>          
          <component :is="componentLineName" :itemTypeName="itemTypeName" :item="layer" v-for="layer in group.values" :key="layer.id" />        
        </v-expansion-panel-content> 

         <v-expansion-panel-content v-for="group in groupMissionLayers" :key="group.key">
          <div slot="header" class="d-flex align-center" >                       
              <v-icon class="flex-grow-0 mr-2" >mdi-rocket</v-icon>{{group.key}}            
            <!--{{$t(`Pilot.Layer.${group.key}`).replace('Pilot.Layer.','')}}-->
          </div>          
          <component :is="componentLineName" :itemTypeName="itemTypeName" :item="layer" v-for="layer in group.values" :key="layer.id" />        
        </v-expansion-panel-content>         
        <v-expansion-panel-content v-for="group in groupMissionGlobalsLayers" :key="group.key">
          <div slot="header" class="d-flex align-center" >                       
              <v-icon class="flex-grow-0 mr-2" >mdi-rocket-outline</v-icon>{{group.key}}            
            <!--{{$t(`Pilot.Layer.${group.key}`).replace('Pilot.Layer.','')}}-->
          </div>          
          <component :is="componentLineName" :itemTypeName="itemTypeName" :item="layer" v-for="layer in group.values" :key="layer.id" />        
        </v-expansion-panel-content> 
      </v-expansion-panel>      
    </div>
  </v-layout>
</template>
<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import AdminMapLayerListLine from '@/components/admin/mapLayer/AdminMapLayerListLine.vue'
import MissionOperatorFilter from '@/components/mission/MissionOperatorFilter.vue'
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
import {  groupBy } from '@/utils/groupBy'
import { camelCase } from 'lodash'

@Component({
  name: 'AdminMapLayerList',  
  components: {AdminMapLayerListLine,MissionOperatorFilter}
})

export default class AdminMapLayerList extends AdminList<AloDbMapLayer> {  

  editLayerKey = ""
  editLayerNewName = ""
 
  get itemTypeName() {
    return "MapLayer"
  }
  

  get componentLineName() {
    return 'AdminMapLayerListLine'
  }


  get groupLayers()
  {    
      return  groupBy(this.layers,it => it.LAY_GROUP_NAME ?? "__ No Group __").sort((a,b) => (a.key.localeCompare(b.key)))
  }

  get groupMissionLayers()
  {    
      return  groupBy(this.missionsLayers.sort((a,b) => ((this.adminMissionsById[a.MIS_ID!]?.MIS_LIBELLE ?? "").localeCompare(this.adminMissionsById[b.MIS_ID!]?.MIS_LIBELLE ?? ""))) ,it => this.adminMissionsById[it.MIS_ID!]?.MIS_LIBELLE?.split('_')[0] ?? "__ No Mission __").sort((a,b) => (a.key.localeCompare(b.key)))
  }

  get groupMissionGlobalsLayers()
  {    
      return  groupBy(this.missionsGlobalLayers.sort((a,b) => ((this.missionGlobalsById[a.MIG_ID!]?.MIG_LIBELLE ?? "").localeCompare(this.missionGlobalsById[b.MIG_ID!]?.MIG_LIBELLE ?? ""))) ,it => this.missionGlobalsById[it.MIG_ID!]?.MIG_LIBELLE ?? "__ No Smart Simulation __").sort((a,b) => (a.key.localeCompare(b.key)))
  }

  get basicLayers(){
    //@ts-ignore
    return this.items.filter(l => (this.canAdminGlobal || l.LAY_SCOPE != "GLO") && l.LAY_SCOPE != "MIG" && l.LAY_SCOPE != "MIS" && (JSON.parse((l.LAY_CONFIG_JSON?.length ??0) > 0?l.LAY_CONFIG_JSON:'{}')?.isBasic ?? false))
  }

  get layers(){
    //@ts-ignore
    return this.items.filter(l => (this.canAdminGlobal || l.LAY_SCOPE != "GLO") && l.LAY_SCOPE != "MIG" && l.LAY_SCOPE != "MIS" && !(JSON.parse((l.LAY_CONFIG_JSON?.length ??0) > 0?l.LAY_CONFIG_JSON:'{}')?.isBasic ?? false))
  }

  get missionsLayers(){
    return this.items.filter(l => l.LAY_SCOPE == "MIS")
  }

  get missionsGlobalLayers(){
    return this.items.filter(l => l.LAY_SCOPE == "MIG")
  }

  get isOperator()
  {
    return this.$store.myGetters.isOperator
  } 

  get isSysAdmin()
  {
    return this.$store.myGetters.isSysAdmin
  }  


  get selectedFilterEnsId()
  {
    //@ts-ignore
    return this.$store.myGetters.filterMission?.ensIds?.at(0) ?? undefined
  }

  get items():Array<AloDbMapLayer> {    
    //@ts-ignore
    return this.$store.myGetters.mapLayers.filter(l =>   (this.filter.search.length == 0 ||  l.searchString.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1) && 
                                                         (
                                                            this.selectedFilterEnsId == undefined || l.LAY_SCOPE == 'GLO' || 
                                                            (l.LAY_SCOPE == 'MIS'  && this.glidersById[this.adminMissionsById[l.MIS_ID!]?.GLI_ID!]?.ENS_ID == this.selectedFilterEnsId) || 
                                                            (l.LAY_SCOPE == 'MIG'  && this.missionGlobalsById[l.MIG_ID!]?.ENS_ID == this.selectedFilterEnsId) || 
                                                            (l.LAY_SCOPE == 'ENS'  && l.ENS_ID == this.selectedFilterEnsId)
                                                          ))
  }

  get adminMissionsById(){
    return this.$store.myGetters.adminMissionsById
  }

  get missionGlobalsById(){
    return this.$store.myGetters.missionGlobalsById
  }

  get glidersById(){
    return this.$store.myGetters.glidersById
  }

  get canAdminGlobal(){
    return this.$store.myGetters.isSysAdmin || this.$store.myGetters.isManager
  }

  editLayerName(group:{key:string,values:Array<AloDbMapLayer>}) {
    this.editLayerKey = group.key;
    this.editLayerNewName = group.key;
  }

  saveLayerName(group:{key:string,values:Array<AloDbMapLayer>}) {
    this.$store.myActions.MAPLAYER_SET_GROUP_NAME_REQUEST({
      layerIds:group.values.map(it => it.LAY_ID!),
      groupName:this.editLayerNewName
    })
    this.cancelLayerName()
  }

  cancelLayerName(){
    this.editLayerKey = "";
  }

}
</script>
<style scope>  
 .liste {
    flex: 1 1 auto;
    overflow: auto;
    height: min-content;
  }  
</style>